import { useLocation } from "react-router-dom";

const Navbar = () => {
  const { pathname } = useLocation();
  return (
    <nav className="flex bg-dark text-white justify-between items-center px-section-x py-section-y fixed w-full top-0">
      <p>Demo</p>

      <ul className="flex justify-center items-center gap-2">
        <a href={"/"}>
          <li
            className={`px-4 py-2 rounded-lg hover:bg-black ${
              pathname === "/" ? "bg-black" : ""
            }`}
          >
            Liveness
          </li>
        </a>
        <a href={"/biometric"}>
          <li
            className={`px-4 py-2 rounded-lg hover:bg-black ${
              pathname === "/biometric" ? "bg-black" : ""
            }`}
          >
            Biometric
          </li>
        </a>
      </ul>
    </nav>
  );
};

export default Navbar;
